import React from 'react';
import { Link, useParams } from 'react-router-dom';

const NotFoundPage = () => {
  const { tenantName } = useParams();

  return (
    <div 
      data-testid="not-found-page"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        textAlign: 'center'
      }}>
      <h1 style={{ fontSize: '4rem', margin: 0, color: '#333' }}>404</h1>
      <h2 style={{ margin: '1rem 0', color: '#666' }}>Page Not Found</h2>
      <p style={{ margin: '1rem 0', color: '#888' }}>
        The page you're looking for doesn't exist.
      </p>
      {tenantName && (
        <Link 
          to={`/${tenantName}/`}
          data-testid="back-to-login"
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#007bff',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            display: 'inline-block',
            marginTop: '1rem'
          }}
        >
          Go to {tenantName} Login
        </Link>
      )}
    </div>
  );
};

export default NotFoundPage; 